
<h2>KEY PERFORMANCE INDICATORS</h2>
<kendo-sortable  class="cards-container" [kendoSortableBinding]="selectedKPIs" *ngIf="widgetData"
[disabledIndexes]="disabledIndexes"
    itemClass="kpi-card">
    <ng-template let-item="item" let-i="index">
        <div class="draggable-section" [style.backgroundColor]="getBackroundColor(i)">
           
            <div style="display: table-cell; vertical-align: middle;">
              <div>
                <div class="kpi-title" >{{ getKpiName(item) |  uppercase}}
                   
                </div>
                <div class="kpi-value"> {{getKpiValue(item, widgetData)}}</div>
              </div>
            </div>
          </div>
    </ng-template>
</kendo-sortable>
